import Vue from 'vue'
import VConsole from 'vconsole'
import 'amfe-flexible'
import clipboard from 'clipboard'
import '@/utils/rem.js'
import '@/styles/index.less'
import config from '@/config'
import App from './App.vue'
import router from './router'
import store from './store'
// import { drag, wexinPay } from '@/utils'
/* eslint-disable */
if (config.debug) {
  var vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.prototype.clipboard = clipboard;

Vue.config.productionTip = false
// Vue.directive('drag', drag)
// Vue.use(wexinPay)
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
